import React, { Component, Fragment } from "react";

import Immutable, { is } from "immutable";

import * as XLSX from 'xlsx';

import axios from "axios";

import { Table, Container, Row, InputGroup, Col, Navbar, NavbarBrand, Nav, NavItem, NavLink, Card, CardBody, CardTitle, CardSubtitle, CardText, Button, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, ButtonGroup, FormGroup, Label, Input } from "reactstrap";
import moment from "moment";
import HeaderComponent from "../header/HeaderComponent";
import TagComponent from "../element/TagComponent";
import TaskComponent from "../element/TaskComponent";
import LoadingScreen from "../element/LoadingScreen";

import LinearGauge from "../element/LinearGauge";
import '../../css/ImageTable.css';
const { Base64 } = require("js-base64");


class ProductPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			totalCount: 0,
			productHistory: [],
			project_name: "mtest",
			data: [],
			project_list: [],
			selectedProjectName: "",
			isModalOpen: false,
			modalImageSrc: '',
			isRejctModelOpen: false,
			rejectTargetIdx: undefined,
			rejectReason: "",
			currentRejectReason: "",
			search_seq: "",
			modalImageSrc2: '',
			leftCount: -1,
			currentCheckTag: "featured",
			onDownloadAll: false,
			currentDownloadUrl: "",
			possbileTagList: [],
			taskTags: [],
			newTagName: "",
			newTagContent: "",
			currentTagIdx: -1,
			taskList: [],
			selectedMode: "ready",
			currentSelectedTask: undefined,
			statusCounts: {
				reject: 0,
				success: 0,
				accept: 0,
				hold: 0,
				ready: 0
			},
			mixModalOpen: false,
			mixModelSrc: "",
			mixModelSeq: "",
			isLoading: false,

		};
		this.handleKeyPress = this.handleKeyPress.bind(this);
		this.modalRef = React.createRef();
		window.that = this;
	}



	handleKeyPress(event) {
		// Check if modal is open
		if (!this.state.isModalOpen) {
			return;
		}

		// Exclude cases where Ctrl or Alt is pressed
		if (event.ctrlKey || event.altKey) {
			return;
		}

		// Handle key presses
		switch (event.key.toLowerCase()) {
			case "a":
				this.updateProductStatus(this.state.currentItem.idx, "accept");
				break;

			case "d":
				this.updateProductStatus(this.state.currentItem.idx, "reject");
				break;

			case "f":
				this.getProductData(undefined, this.state.currentItem && this.state.currentItem.product_id);
				break;

			case "b":
				this.goback();
				break;

			default:
				console.log("Key not bound to a function.");
		}
	}



	handleClickOutside = (event) => {
		console.log("click outside")
		if (this.modalRef.current && !this.modalRef.current.contains(event.target)) {
			this.closeModal();
		}
	};
	loadMixModel = async (seq) => {

		if (seq == "") {
			alert("모델 시퀀스를 입력해주세요.");
			return;
		}


		this.setState({
			mixModelSrc: `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/admin/task/image?seq=${seq}&type=model`,
		});

	}

	closeMixModal = () => {

		this.setState({ mixModalOpen: false });
	};
	mixModalOpen = () => {
		this.setState({ mixModalOpen: true });
	}
	componentWillUnmount() {
		document.removeEventListener("mousedown", this.handleClickOutside);
		window.removeEventListener("keydown", this.handleKeyPress);
	}


	async componentDidMount() {
		document.addEventListener("mousedown", this.handleClickOutside);
		window.addEventListener("keydown", this.handleKeyPress);
		this.getProjectList();

		const searchParams = new URLSearchParams(window.location.search);
		let paramValue = searchParams.get("project_name");
		console.log(paramValue);
		if (paramValue) {
			this.setState({ selectedProjectName: paramValue })
		}
	}
	getPossbleTagList = async () => {
		const result = await axios({
			method: "Get",
			url: `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/admin/tag`,
			params: {

			},
			headers: {
				Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
			},
		});
		const tag_list = JSON.parse(result.data.body).tag_list;
		tag_list.sort((a, b) => {
			return a.name.localeCompare(b.name);
		});
		this.setState({ possbileTagList: tag_list, currentTagIdx: tag_list[0].idx }, () => {


		});
	}


	getProjectList = async () => {
		const result = await axios({
			method: "Get",
			url: `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/charan/project/list`,
			params: {


			},
			headers: {
				Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
			},
		});
		const projects = JSON.parse(result.data.body).project_list;
		projects.unshift({ project_name: "프로젝트 선택" })
		this.setState({
			project_list: projects,

			//selectedProjectName: "rlabs_241118"
		}, () => {


			this.getProductData();

		});
	}
	goback = () => {
		const productHistory = this.state.productHistory;
		if (productHistory.length <= 1) {
			return;
		}
		//need to pop twice as current product is already in the array
		productHistory.pop();
		const product_id = productHistory.pop();
		console.log("preve:", product_id)
		if (product_id != undefined) {
			this.setState({ productHistory: productHistory }, () => {
				this.getProductData(product_id);
			});
		}
	}


	getProductData = async (product_id, excludeProductId, retry = 0) => {

		if (this.state.selectedProjectName == "") {
			return;
		}
		const result = await axios({
			method: "Get",
			url: `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/charan/project/product`,
			params: {
				project_name: this.state.selectedProjectName,
				random_one: "true",
				product_id: product_id,
					exclude_product_id: excludeProductId,

			},
			headers: {
				Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
			},
		});
		const tasks = JSON.parse(result.data.body).tasks;
		const totalCount = JSON.parse(result.data.body).total_count;
		const leftCount = JSON.parse(result.data.body).left_count;

		//if task item has discard field and if its true, set discarded to true
		tasks.forEach((task) => {
			if (task.discard && task.discard == "true") {
				task.discarded = true;
			}
		});

		const statusCounts = {
			reject: 0,
			success: 0,
			accept: 0,
			hold: 0,
			ready: 0
		};
		tasks.forEach(item => {
			if (statusCounts.hasOwnProperty(item.customer_check_status)) {
				statusCounts[item.customer_check_status]++;
			}
		});


		// read-lag로 방금 판정한 항목이 random_one에 다시 잡히면, 잠깐 뒤 재시도해
		// 건너뛴다 → 판정 즉시 다음 미판정 건으로 자동 이동 (수동 "다음" 클릭 불필요)
		if (tasks[0] && excludeProductId && tasks[0].product_id === excludeProductId && retry < 6) {
			setTimeout(() => this.getProductData(undefined, excludeProductId, retry + 1), 400);
			return;
		}

		//set to state
		if (tasks[0] == undefined) {
			this.setState({ isLoading: false, statusCounts: statusCounts, data: tasks, leftCount: leftCount, totalCount: totalCount, isModalOpen: false }, () => {
				if (this.state.leftCount == 0) {
					alert("모든 작업이 완료되었습니다. 전체검수 메뉴에서 다운로드 받아주세요")
					window.location = "/product";
					return;
				}
			});
		}
		else {


			let productHistory = this.state.productHistory;
			productHistory.push(tasks[0].product_id);
			if (productHistory.length > 10) {
				productHistory.shift();
			}
			console.log(productHistory);

			this.setState({ productHistory: productHistory, isLoading: false, statusCounts: statusCounts, totalCount: totalCount, data: tasks, currentItem: tasks[0], leftCount: leftCount, isModalOpen: true, modalImageSrc: this.generateImageUrl(tasks[0]), modalImageSrc2: this.generateResultUrl(tasks[0]) }, () => {
				if (this.state.leftCount == 0) {
					alert("모든 작업이 완료되었습니다.")
					return;
				}
				this.getProductTask(tasks[0].seq1);
			});
		}
	}
	generateImageUrl(item, thumnail) {
		if (!item) {
			return "";
		}
		if (thumnail) {
			return `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/public/download/image?project_name=${item.project_name}&seq=${item.seq1}&type=input&version=${item.version}&width=500&height=500`

		}
		return `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/public/download/image?project_name=${item.project_name}&seq=${item.seq1}&type=input&version=${item.version}&noresize=1`
	}

	generateModelUrl(item, thumnail) {
		if (!item) {
			return "";
		}
		if (thumnail) {
			return `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/public/download/image?project_name=${item.project_name}&seq=${item.seq}&type=output&version=${item.version}&width=500&height=500`
		}
		return `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/public/download/image?project_name=${item.project_name}&seq=${item.seq}&type=output&version=${item.version}&noresize=1`
	}

	generateResultUrl(item, thumnail) {
		if (!item) {
			return "";
		}
		if (thumnail) {
			return `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/public/download/image?project_name=${item.project_name}&seq=${item.seq1}&type=output&width=500&height=500`
		}
		return `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/public/download/image?project_name=${item.project_name}&seq=${item.seq1}&type=output&noresize=1&small=1`
	}

	setCurrentSelectedTask = (task) => {
		this.setState({ currentSelectedTask: task });
	}

	// Open modal if Ctrl is pressed when clicking on result image
	handleResultClick = (item) => {

		let url = "";
		this.getProductTask(item.seq1);
		this.setState({ currentItem: item, isModalOpen: true, modalImageSrc: this.generateImageUrl(item), modalImageSrc2: this.generateResultUrl(item) }, () => {
			this.getProductTask(item.seq1);
		},);

	};
	getProductTask = async (seq) => {
		const result = await axios({
			method: "Get",
			url: `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/charan/project/product/task`,
			params: {
				seq: seq,

			},
			headers: {
				Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
			},
		});
		const task = JSON.parse(result.data.body).task;


		this.setState({ currentSelectedTask: task });
	}
	// Close the modal
	closeModal = () => {
		console.log("modal closed");
		this.setState({ isModalOpen: false, modalImageSrc: '', isRejctModelOpen: false, rejectTargetIdx: undefined, isShowRejectReasonOpen: false });
	};



	onValueChanged = (name, value) => {

		console.log("name:", name, ",value:", value)

		this.setState({
			[name]: value

		}, () => {
			if (name == "selectedProjectName") {
				this.getProductData();
			}
		});

	};
	toggleExcludeEvaluated = () => {
		// Toggle excludeEvaluated state
		this.setState((prevState) => ({
			excludeEvaluated: !prevState.excludeEvaluated
		}));
	};

	updateProductStatus = async (productIdx, status) => {

		this.setState({ isLoading: true });
		try {
			await axios({
				method: "Put",
				url: `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/charan/project/product`,
				data: {
					product_idx: productIdx + "",
					check_status: status

				},
				headers: {
					Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
				},
			});
		} catch (e) {
			//alert(e)
			return;
		}

		this.setState((prevState) => ({
			data: prevState.data.map((item) => {
				if (item.idx === productIdx) {


					return {
						...item,
						customer_check_status: status,
					}
				}
				return item;

			}),
			currentItem: {
				...prevState.currentItem,
				customer_check_status: status
			},

		}));
		// 방금 판정한 항목 id를 넘겨 자동으로 다음 미판정 건으로 이동.
		// (random_one이 read-lag로 방금 판정한 걸 다시 주면 getProductData가 건너뜀)
		const justJudgedProductId = this.state.currentItem && this.state.currentItem.product_id;
		this.getProductData(undefined, justJudgedProductId);

	};

	downloadAll = async () => {

		if (this.state.onDownloadAll && this.state.currentDownloadUrl) {
			window.open(this.state.currentDownloadUrl, '_blank')
			return;
		}

		// 단일 zip(비동기): start → status 폴링 → 완성되면 zip 1개 다운로드. 대용량(수백장)도 30초 벽 없이.
		const projectName = this.state.selectedProjectName;
		const authHeader = { Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken };
		const DOWNLOAD_BASE = process.env.REACT_APP_PROJECT_DOWNLOAD_ALL;
		this.setState({ onDownloadAll: true })
		try {
			await axios({ method: 'POST', url: `${DOWNLOAD_BASE}/start`, params: { project_name: projectName }, headers: authHeader });
			for (let i = 0; i < 120; i++) {
				// eslint-disable-next-line no-await-in-loop
				const stRes = await axios({ method: 'GET', url: `${DOWNLOAD_BASE}/status`, params: { project_name: projectName }, headers: authHeader });
				const st = JSON.parse(stRes.data.body);
				if (st.state === 'ready') {
					this.setState({ currentDownloadUrl: st.downloadUrl });
					window.open(st.downloadUrl, '_blank');
					return;
				}
				// eslint-disable-next-line no-await-in-loop
				await new Promise((r) => setTimeout(r, 3000));
			}
			alert("압축파일 생성이 오래 걸립니다. 잠시 후 다시 눌러주세요.");
			this.setState({ onDownloadAll: false });
		}
		catch (e) {
			alert("파일 키가 없거나 올바른 요청이 아닙니다.")
			console.log(e)
			this.setState({ onDownloadAll: false });
		}

	};
	exportToExcel = () => {

		const filteredData = this.state.data.filter(item => {
			return item.check_status == "accept";
		});
		const rawdata = filteredData.map(item => {
			const { idx, seq, discard, category, product_id, ...rest } = item;  // Remove the discarded property
			return {

				id: product_id,
				check_status: "accept",
				category_2: "-",
				org_file_name: item.org_file_name,
				reject_reason: "-",
				project_name: item.project_name,
				status: "succeed",
				category: item.category,
				url: `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/public?seq=${item.seq1}` // Custom column based on seq
			};
		});

		// Convert updated data to sheet
		const ws = XLSX.utils.json_to_sheet(rawdata);
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "Data");

		// Export as Excel file
		XLSX.writeFile(wb, `fssnap_${this.state.selectedProjectName}_${moment().format("YYYY_MM_DD_HH_mm")}.xlsx`);
	};
	getCurrentStatus = (status) => {
		if (status == "accept") {
			return (<span style={{ fontWeight: "bold", color: "green" }}>수락</span>)
		}
		else if (status == "hold") {
			return (<span style={{ fontWeight: "bold", color: "orange" }}>보류</span>)
		}
		else if (status == "reject") {
			return (<span style={{ fontWeight: "bold", color: "red" }}>제외</span>)
		}
		else {
			return (<span style={{ fontWeight: "bold", color: "purple" }}>검수 전</span>)
		}
	}
	getCurrentTile = (status) => {
		if (status == "accept") {
			return (<h2 style={{ fontWeight: "bold", color: "green" }}>현재상태 : 수락</h2>)
		}
		else if (status == "hold") {
			return (<h2 style={{ fontWeight: "bold", color: "orange" }}>현재상태 : 보류</h2>)
		}
		else if (status == "fail") {
			return (<h2 style={{ fontWeight: "bold", color: "red" }}>현재상태 : 실패</h2>)
		}
		else {
			return (<h2 style={{ fontWeight: "bold", color: "purple" }}>현재상태 : 검수 전</h2>)
		}
	}
	render() {
		let filteredData = this.state.data;
		if (this.state.selectedMode == "accept") {
			filteredData = this.state.data.filter(item => item.customer_check_status == 'accept');
		}
		if (this.state.selectedMode == "hold") {
			filteredData = this.state.data.filter(item => item.customer_check_status == 'hold');
		}
		if (this.state.selectedMode == "ready") {
			filteredData = this.state.data.filter(item => item.customer_check_status == 'ready');
		}
		if (this.state.selectedMode == "fail") {
			filteredData = this.state.data.filter(item => item.customer_check_status == 'fail');
		}

		return (
			<Fragment>
				<LoadingScreen isLoading={this.state.isLoading} />
				{this.state.isModalOpen && (
					<div className="modals"
						zIndex={1500}
						style={{

						}} >
						<div className="modal-contents" ref={this.modalRef} style={{ width: "95%", }}>
							<div style={{ width: "100%", fontSize: 25, color: "black", fontWeight: 800, marginBottom: "5px" }}>
								<Col md={1}>검수 진행
								</Col>
								<Col md={5}>
									<LinearGauge
										justifyContent={"start"}
										value={this.state.totalCount - this.state.leftCount} max={this.state.totalCount} width={300} height={20} color="#4caf50" trackColor="#e0e0e0" />
								</Col>

							</div>

							<div style={{
								width: "100%", display: "flex",

								"justify-content": "space-between"
							}}>
								<img onClick={() => { this.closeModal() }} style={{
									display: "block",
									"margin-left": "auto",
									"margin-right": "auto",
									"object-fit": "contain",
									"max-height": 800,
									"max-width": 500
								}} src={this.state.modalImageSrc} alt="Large version" className="modal-image" />
								<img onClick={() => { this.closeModal() }} style={{
									display: "block",
									"margin-left": "auto",
									"margin-right": "auto",
									"object-fit": "contain",
									"max-height": 640
								}} src={this.state.modalImageSrc2} alt="Large version" className="modal-image" />
								<div>
									<table style={{ width: "100%", border: "1px solid black", "border-collapse": "collapse" }}>
										<thead>
											<tr>
												<th style={{ width: "70%" }}>Prop</th>
												<th style={{ width: "50%" }}>Value</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td className="tb_td">ProductId</td>
												<td className="tb_td">{this.state.currentSelectedTask?.product_id}</td>
											</tr>
											<tr>
												<td className="tb_td">seq</td>
												<td className="tb_td">{this.state.currentSelectedTask?.seq}</td>
											</tr>
											<tr>
												<td className="tb_td">카테고리</td>
												<td className="tb_td">{this.state.currentSelectedTask?.category_1}</td>
											</tr>
											<tr>
												<td className="tb_td">Total</td>
												<td className="tb_td">{this.state.currentSelectedTask?.size_total}</td>
											</tr>
											<tr>
												<td className="tb_td">Hip</td>
												<td className="tb_td">{this.state.currentSelectedTask?.size_hip}</td>
											</tr>

											<tr>
												<td className="tb_td">Waist</td>
												<td className="tb_td">{this.state.currentSelectedTask?.size_waist}</td>
											</tr>
											<tr>
												<td className="tb_td">Breast</td>
												<td>{this.state.currentSelectedTask?.size_breast}</td>
											</tr>
											<tr>
												<td className="tb_td">Sleeve</td>
												<td className="tb_td">{this.state.currentSelectedTask?.size_sleeve}</td>
											</tr>
											<tr>
												<td className="tb_td">Shoulder</td>
												<td className="tb_td">{this.state.currentSelectedTask?.size_shoulder}</td>
											</tr>
											<tr>
												<td className="tb_td">검수 상태</td>
												<td className="tb_td">{this.getCurrentStatus(this.state.currentItem.customer_check_status)}</td>
											</tr>
										</tbody>
									</table>
								</div>

							</div>
							<div style={{ float: "right" }}>
								<Button
									color="success"
									onClick={() => {
										this.updateProductStatus(this.state.data[0].idx, "accept");
									}}
								>
									수락(A)
								</Button>
								<Button
									color="danger"
									onClick={() => {
										this.updateProductStatus(this.state.data[0].idx, "reject");
									}}
								>
									제외(D)
								</Button>
								<Button
									color="warning"
									onClick={() => {
										this.goback();
									}}
								>
									뒤로(B)
								</Button>
								<Button
									color="info"
									onClick={() => {
										this.getProductData(undefined, this.state.currentItem && this.state.currentItem.product_id);
									}}
								>
									다음(F)
								</Button>

							</div>
						</div>

					</div>)}



				<HeaderComponent signOut={this.props.cognito.signOut} setStage={this.props.setStage} stage={this.props.stage}></HeaderComponent>
				<div className="main_contents">
					<Container fluid>
						<Row>
							<div className="x_panel" style={{ alignItems: "center", display: "flex", justifyContent: "center" }}>
								<Col md={4}>

									<Col md={2}>
										<ButtonGroup>
											<Button
												color="info"
												onClick={() => {
													this.getProductData();
												}}
											>
												Refresh
											</Button>
										</ButtonGroup>
									</Col>
									<Col md={3}>

										{/* <ButtonGroup>
											<Button
												color="primary"
												outline
												onClick={() => {
													this.toggleExcludeEvaluated();
												}}
												active={this.state.excludeEvaluated}
											>
												검수된 항목 제외
											</Button>
										</ButtonGroup> */}
									</Col>
									<Col md={3}>

									</Col>
									{/* <Col md={3}>
										<Input

											type="text"
											className="form-control"
											placeholder="search_seq"
											value={this.state.search_seq}
											onChange={(val) => {
												this.onValueChanged("search_seq", val.target.value);
											}}
										/>

									</Col> */}
								</Col>

								<Col md={4} style={{ alignItems: "center", display: "flex", fontSize: 25, color: "black", fontWeight: 800, justifyContent: "center" }}>
									{`${(this.state.leftCount > 0) ? `검수 준비:${this.state.leftCount}` : "프로젝트를 선택해주세요"}`}
								</Col>
								<Col md={4}>

									<Col md={3}>

									</Col>
									<Col md={3}>

									</Col>
									<Col md={2}>
										프로젝트 선택:
									</Col>
									<Col md={4}>
										<Input value={this.state.selectedProjectName}

											style={{}}
											onChange={(e) => this.onValueChanged("selectedProjectName", e.target.value)} id="selectedProjectName" name="selectedProjectName" type="select">

											{this.state.project_list.map((item) => (
												<option value={item.project_name}>{item.project_name}</option>
											)
											)}


										</Input>
									</Col>
								</Col>
							</div>
							<div className="x_panel" style={{ alignItems: "center", display: "flex", justifyContent: "center" }}>
								<div className="table-container">
									<table>
										<thead>
											<tr>
												<th>Idx</th>
												<th>product_id</th>

												<th>Original Image</th>

												<th>현재 후보</th>
												<th>컨트롤</th>
												<th>검수상태</th>

											</tr>
										</thead>
										<tbody>
											{filteredData.map((item) => (
												<tr
													key={item.idx}


												>
													<td className="table-cell">{item.idx}</td>
													<td className="table-cell">{item.product_id}</td>


													<td className="table-cell">
														<img
															style={{ "max-width": "200px", "object-fit": "contain" }}
															src={this.generateImageUrl(item)}
															alt={item.filename}

															onClick={(e) => this.handleResultClick(item, "input")}
														/>
													</td>


													<td className="table-cell">
														<img
															src={this.generateResultUrl(item)}
															alt={`result-${item.filename}`}

															onClick={(e) => this.handleResultClick(item, "result")}  // Handle Ctrl + Click
														/>
													</td>
													<td className="table-cell">
														<Button
															color="info"
															onClick={() => {
																this.updateProductStatus(item.idx, "accept");
															}}
														>
															수락
														</Button>
														<br></br>
														{
															(item.check_status != "reject") ? (
																<Button
																	color="danger"
																	onClick={() => {
																		this.updateProductStatus(item.idx, "reject");
																	}}
																>
																	제외
																</Button>) : ""}
														<br></br>

													</td>
													<td className="discard-status" >{
														this.getCurrentStatus(item.customer_check_status)


													}

													</td>

												</tr>
											))}
										</tbody>
									</table>


								</div>
							</div>
						</Row>
					</Container>
				</div >
			</Fragment >
		);
	}
}

export default ProductPage;
